import { TariffFilter } from '../api/tariffApi';
import { DropdownItem, TariffDropdownItem } from '../components/ui/input/DropdownInput';
import { SimManagementError } from '../models/Errors';
import {
  ENSURE_NETWORK_BUNDLE_TOPUPS,
  ENSURE_NETWORK_TARIFFS,
  LOAD_NETWORK_BUNDLE_TOPUPS,
  LOAD_NETWORK_BUNDLE_TOPUPS_FAILURE,
  LOAD_NETWORK_BUNDLE_TOPUPS_PENDING,
  LOAD_NETWORK_BUNDLE_TOPUPS_SUCCESS,
  LOAD_NETWORK_TARIFFS,
  LOAD_NETWORK_TARIFFS_FAILURE,
  LOAD_NETWORK_TARIFFS_PENDING,
  LOAD_NETWORK_TARIFFS_SUCCESS,
} from './actionTypes';
import { Action, ActionMeta, PromiseAction, RejectFunc, ResolveFunc } from './commonActions';

export function ensureNetworkBundleTopups(payload: number): Action<number> {
  return {
    type: ENSURE_NETWORK_BUNDLE_TOPUPS,
    payload,
  };
}

export function ensureNetworkTariffs(payload: TariffFilter): Action<TariffFilter> {
  return {
    type: ENSURE_NETWORK_TARIFFS,
    payload,
  };
}

export function loadNetworkBundleTopups(
  networkId: number,
  resolve?: ResolveFunc<DropdownItem[]>,
  reject?: RejectFunc,
): PromiseAction<number, DropdownItem[]> {
  return {
    type: LOAD_NETWORK_BUNDLE_TOPUPS,
    payload: networkId,
    resolve,
    reject,
  };
}

export function loadNetworkBundleTopupsPending(networkId: number): Action<number> {
  return {
    type: LOAD_NETWORK_BUNDLE_TOPUPS_PENDING,
    payload: networkId,
  };
}

export function loadNetworkBundleTopupsFailure(
  networkId: number,
  error: SimManagementError,
): ActionMeta<number, SimManagementError> {
  return {
    type: LOAD_NETWORK_BUNDLE_TOPUPS_FAILURE,
    payload: networkId,
    meta: error,
  };
}

export function loadNetworkBundleTopupsSuccess(
  networkId: number,
  items: DropdownItem[],
): ActionMeta<number, DropdownItem[]> {
  return {
    type: LOAD_NETWORK_BUNDLE_TOPUPS_SUCCESS,
    payload: networkId,
    meta: items,
  };
}

export function loadNetworkTariffs(
  filter: TariffFilter,
  resolve?: ResolveFunc<DropdownItem[]>,
  reject?: RejectFunc,
): PromiseAction<TariffFilter, DropdownItem[]> {
  return {
    type: LOAD_NETWORK_TARIFFS,
    payload: filter,
    resolve,
    reject,
  };
}

export function loadNetworkTariffsPending(filter: TariffFilter): Action<TariffFilter> {
  return {
    type: LOAD_NETWORK_TARIFFS_PENDING,
    payload: filter,
  };
}

export function loadNetworkTariffsSuccess(
  filter: TariffFilter,
  items: TariffDropdownItem[],
): ActionMeta<TariffFilter, DropdownItem[]> {
  return {
    type: LOAD_NETWORK_TARIFFS_SUCCESS,
    payload: filter,
    meta: items,
  };
}

export function loadNetworkTariffsFailure(
  filter: TariffFilter,
  error: SimManagementError,
): ActionMeta<TariffFilter, SimManagementError> {
  return {
    type: LOAD_NETWORK_TARIFFS_FAILURE,
    payload: filter,
    meta: error,
  };
}
